





















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import RoundButton from '@/components/RoundButton.vue';

@Component({
  components: { RoundButton }
})
export default class RoundButtonMenu extends Vue {
  @Prop(String) public tooltip: string | undefined;
  @Prop(String) public icon!: string;
  @Prop(String) public iconSize: string | undefined;
  @Prop({ type: Boolean, default: false }) public disabled!: boolean;
}
